import { CaretRightIcon, LockIcon, TruckIcon } from '@phosphor-icons/react';
import { useState } from 'react';
import { CASH_ADVANCE_LOCKED_COPY } from '../../../../../constants/bankingCopy';
import RentalRequestModal from './RentalRequestModal';

// Rentals V1 — Web. The "Request a Rental" entry on My Resources.
//
// Wears the same full-width row shape as PromoteMyBusinessCard / PMChecklistCard
// and, like them, is a STATIC client-side card rather than an item from the
// resources config. That is what keeps this simple: the config's ResourceItem
// union covers link/phone/modal — things that open something — and a new
// "posts a request" variant would have to be added to the backend union and
// handled on both clients before this could ship anywhere.
//
// It replaces the config's old Rentals section, whose only live item linked
// straight out to a rental company's own site — exactly the direct-to-vendor
// path this closes.
//
// Locked while cash advance is — same rule and copy as RequestRentalEntry.

interface RentalRequestCardProps {
  isCashAdvanceLocked: boolean;
}

const RentalRequestCard = ({ isCashAdvanceLocked }: RentalRequestCardProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        data-testid="resources:requestRental"
        onClick={() => setIsOpen(true)}
        disabled={isCashAdvanceLocked}
        className="flex w-full items-center gap-4 rounded-xl border border-bordergray bg-white p-4 text-left transition-shadow hover:shadow-md disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:shadow-none"
      >
        <div className="flex h-[56px] w-[56px] shrink-0 items-center justify-center rounded-lg bg-primarybg">
          <TruckIcon size={28} weight="regular" className="text-primary" />
        </div>
        <div className="flex flex-1 flex-col gap-1">
          <h3 className="text-base font-semibold text-gray-900">
            Request a Rental
          </h3>
          <p className="text-sm text-gray-600">
            {isCashAdvanceLocked
              ? CASH_ADVANCE_LOCKED_COPY
              : "Need a truck or trailer? We'll set up the rental for you."}
          </p>
        </div>
        {isCashAdvanceLocked ? (
          <LockIcon size={18} className="shrink-0 text-gray-400" />
        ) : (
          <CaretRightIcon size={18} className="shrink-0 text-gray-400" />
        )}
      </button>

      {/* Mounted only while open, so each open is a genuinely fresh form — the
          modal starts a POST the user can walk away from, and keeping the
          instance alive across closes would let a late resolve write into the
          NEXT open (a stale error banner, or the success view on a blank form). */}
      {isOpen && (
        <RentalRequestModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
      )}
    </>
  );
};

export default RentalRequestCard;
